import React from 'react';
import { PluginRegistration } from '@/infra/plugin-registry';
import { contactsReducer } from './ducks';
import { contactsSaga } from './sagas';
// Side-effect: register the contacts @mention provider with the mentions registry.
import './mention-provider';

const LazyContactsPage = React.lazy(
  () => import('./pages/ContactsPage')
);

export const contactsManifest: PluginRegistration = {
  id: 'contacts',
  display_name: 'Contacts',
  description: 'Search lifedb contacts, enable for chores, and enhance with AI',
  version: '1.0.0',
  enabled_by_default: true,
  todo_types: [
    {
      type_tag: 'contacts.linked_todo',
      label: 'Contact-Linked Todo',
    },
  ],
  web_routes: [
    {
      path: '/contacts',
      sidebar_label: 'Contacts',
      sidebar_order: 3,
    },
  ],
  reducer: contactsReducer,
  saga: contactsSaga,
  routes: [LazyContactsPage],
};
